<template>
<div class="pcb-upgerber-file-box mg-b-sm" style="border-bottom: 1px solid #e5e5e5;">
	<div v-show="!isResove" class="quote-fileup quote-box-line pd-t-md" v-cloak>
		<div class="quote-box-items not-upload-box" :class="{'analyzing-bg':actionStatus == 2}" v-if="1" id="dragelement">			
			
			<div v-if="actionStatus == 1">
				<np-upload
					ref="npupFile" class="vlm" v-show="showUpbtn" 
					@onprogress="upfileProgress" 
					@change="getfiles" 
					:opts="upopts"
					@comfiles="comfiles"
					@success="fileupsuccess"
					@clear="clearFileYes"
				>			
					<span class="gerber-viewer-btn" :class="[isfileUp?'disabled-gerber-viewer':'']" slot="btn">
						<i class="icon ">&#xe632;</i> 
						Gerber File
					</span>
				</np-upload>
				<!-- start -->
				<div class="quote-loadfile mg-b-md pd-t-sm" v-if="percentage">
					<div class="quote-loadfile-file clear mg-b-xs flex-center">
						<!-- <span class="fl-lt lt">
							<i class="icon-upload mg-r-sm icon-upload_file" style="float:left;"></i>
							<em class="vlm txt-lt np-upload-preview_name" :title="params.fileName">{{params.fileName}}({{params.size}}kb)</em>
						</span> -->
						<!-- <i @click="clearFiles" class="icon quote-fileup_clear mg-l-sm fc-dis fs-xs">&#xe678;</i> -->
						<i class="icon-upload mg-r-sm icon-upload_file"></i>
						<em class="vlm txt-lt np-upload-preview_name mg-r-bs" :title="params.fileName">{{params.fileName}}({{params.size}}kb)</em>
						<i class="btn-border-close" @click="clearFiles">
							<svg xmlns="http://www.w3.org/2000/svg" width="22.689" height="22.689" viewBox="0 0 22.689 22.689"><defs></defs><g transform="translate(-79 -79)"><path class="icon-close" d="M336.49,357.4a.789.789,0,0,1-.56-.232l-8.079-8.079a.791.791,0,0,1,1.119-1.119l8.079,8.079a.791.791,0,0,1-.56,1.351Z" transform="translate(-242.106 -261.699)"/><path class="icon-close" d="M328.411,357.392a.792.792,0,0,1-.56-1.351l8.079-8.079a.791.791,0,1,1,1.119,1.119l-8.079,8.079A.789.789,0,0,1,328.411,357.392Z" transform="translate(-242.106 -261.689)"/><path class="icon-close" d="M90.345,101.689a11.345,11.345,0,1,1,11.345-11.345A11.358,11.358,0,0,1,90.345,101.689Zm0-21.106a9.762,9.762,0,1,0,9.762,9.762A9.772,9.772,0,0,0,90.345,80.583Z"/></g></svg>
						</i>
						<span class="fl-gt gt" style="position: absolute; top: 17px; right: 0;">{{percentage}}%</span>
					</div>
					<div class="quote-loadfile-progress">
						<div class="quote-loadfile-progress-step trans-animate" :style="{width: percentage + '%'}"></div>
					</div>
					
				</div>
				<!-- end -->
				<p class="file-type-tip pd-t-xs fs-sm">
					{{ LANG.zip_rar_50 }}
				</p>

			</div>

			<div v-if="percentage && actionStatus == 2" class="analyzing-box-quote">
					<!-- <img :src="$imgList.loading_0" alt=""> -->
					<Analyzing></Analyzing>
					<p class="pd-t-sm fs-sm">{{analyzingTip}}
						<span v-if="analyseSetp1Countdown < 60 && analyseSetp1Countdown > 0">{{analyseSetp1Countdown}} s</span>
					</p>
			</div>
			
			<div v-show="isCannotResolved" class="pd-t-sm">
				<p class="flex-center"><i class="icon icon-upload vlm mg-r-sm icon-upload_rar"></i> <span class="fc-gnr mg-r-bs">{{ fileData.name }}</span> 
					<!-- <i class="icon vlm np-upload-preview_clear mg-l-xs fc-dis fs-xs" @click="clearFiles" style="float:none;">&#xe678;</i> -->
					<i class="btn-border-close" @click="clearFiles">
						<svg xmlns="http://www.w3.org/2000/svg" width="22.689" height="22.689" viewBox="0 0 22.689 22.689"><defs></defs><g transform="translate(-79 -79)"><path class="icon-close" d="M336.49,357.4a.789.789,0,0,1-.56-.232l-8.079-8.079a.791.791,0,0,1,1.119-1.119l8.079,8.079a.791.791,0,0,1-.56,1.351Z" transform="translate(-242.106 -261.699)"/><path class="icon-close" d="M328.411,357.392a.792.792,0,0,1-.56-1.351l8.079-8.079a.791.791,0,1,1,1.119,1.119l-8.079,8.079A.789.789,0,0,1,328.411,357.392Z" transform="translate(-242.106 -261.689)"/><path class="icon-close" d="M90.345,101.689a11.345,11.345,0,1,1,11.345-11.345A11.358,11.358,0,0,1,90.345,101.689Zm0-21.106a9.762,9.762,0,1,0,9.762,9.762A9.772,9.772,0,0,0,90.345,80.583Z"/></g></svg>
					</i>
				</p>
				<p class="fc-quotetips pd-t-xs">{{ LANG.cannot_resolved_tip }}</p>
			</div>
			<p v-show="!fileData.name" class="fc-quotetips pd-t-xs fs-sm" style="width:73%; margin:0 auto;" v-html="LANG.resoleLANG('file_parsed_fail',{email:'support@nextpcb.com'})">				
			</p>
		</div>

	</div>
	<!-- 文件解析后 -->
	<div v-show="isResove" class="quote-fileparse mb30">		
		<np-upload
			ref="npupFile2" class="vlm" v-show="showUpbtn" 
			@onprogress="upfileProgress" 
			@change="getfiles" 
			:opts="upopts"
			@success="fileupsuccess"
			@clear="clearFileYes"
		>	
			<template v-slot:btn>
				<div class="quote-loadfile-file"></div>
			</template>
		</np-upload>
		<div class="quote-loadfile mt20" v-show="nextUpPercent">
			<div class="quote-loadfile-file clear" style="padding-bottom: 10px;">
				<span class="fl-lt lt">
					<i class="icoy-zip vlm"></i>
					<em class="vlm">{{params.fileName}}({{params.size}}kb)</em>					
				</span>
				<span class="fl-gt gt">{{percentage}}%</span>
			</div>
			<div class="quote-loadfile-progress">
				<div class="quote-loadfile-progress-step trans-animate" :style="{width: percentage + '%'}"></div>
			</div>
		</div>
		<ul class="quote-loadfile-arg">
			<li>
				Currently showing the analysis file: <a class="fc-blue"  :href="resoveData.file_path"> <template v-if="file_list[key]">{{file_list[key].name}}</template> ({{fileData.size || params.size}}kb)</a>
			</li>
			<li>
				{{ LANG.size }}: <a class="fc-blue"  href="javascript:void(0);">{{$tools.keepDecimal(resoveData.dpcsLength,2)}} × {{$tools.keepDecimal(resoveData.dpcsWidth,2)}}mm ({{(resoveData.dpcsWidth/25.4).toFixed(1)}} × {{(resoveData.dpcsLength/25.4).toFixed(1)}}inches)</a>
			</li>
		</ul>
		<div class="quote-loadfile-tips">
			<i>!</i>
			<p class="fc-quotetips">{{LANG.upload_file_parsed_success_tips}}</p>
		</div>
		
	</div>
	<div v-if="isResove && resolveImg.top" class="resolve-img mb30">
		<div>
			<img :src="resolveImg.top">
		</div>
		<div>
			<img :src="resolveImg.bot">
		</div>
	</div>
	<div class="txt-gt pd-t-sm pd-b-sm" v-if="!isInDFM && !isChangeParams">
		<a class="pcb-gerberview-link fc-bs" target="_blank" :href="newDfmUrl" @click="handleGoDfm" >
			<i class="icon f-bold mg-r-xs">&#xe64f;</i>
			{{LANG.online_gerber_viewer_pro}}
		</a>
	</div>
</div>
</template>

<script>
import upload from '@/_module/upload/index.vue'
import Analyzing from '@/components/analyzing.vue'
export default {
	props:['type','pcbParams'],
	components:{
		"np-upload":upload,
		Analyzing
	},
	data(){
		return {
			isfileUp:false,
			upopts: {				
				accept:".zip,.rar",
				upfile: this.$api.upfile,
				multiple: false,//多文件上传
				showprocess: false,
				type: "pcbfile",
				interId:0,
				params:{
					quote: "analysis"
				},
				maxsize: 50,				
				fileNameSize: [5, 100],
        fileNameSizeTip: this.LANG.file_name_limit_tip,
				dragelement:"dragelement",
				formatErrorTip:()=>{
					this.$alert.toast(this.LANG.check_file_format,{type:"error"}, 4000)
				},
				maxSizeTip:(size)=>{
					//this.MLANG.gerber_file_limit_tip,
					this.$alert.toast(this.LANG.resoleLANG('check_file_size',{size}),{type:"error"})
				}
				//type:"sale_quote" //根据上传参数添加
			},
			params:{
				//文件名称
				fileName: "",
				//文件大小
				size: 0
			},
			kicadid:"",
			fid:"",
			//上传按钮是否显示
			showUpbtn: true,
			isResove: false,			
			//上传进度
			percentage:0,
			file_list:[],
			nextUpPercent: false,
			key:0,
			resoveCount:0,
			//请求后获取到的数据
			resoveData:{},
			fileData: {}, // 上传成功后文件信息
			isCannotResolved: false, // 文件是否无法解析
			analyseId: null, // 新版dfm解析id
			analyseOrderParams: {}, // 新版dfm返回的解析结果
			analyseQuoteParams: {}, // 新版dfm返回的解析计价参数
			analyseTimer:null, // 新版dfm延时器
			resolveImg:{}, // 解析出来的仿真图
			analyzingTip: 'Analyzing..',
			actionStatus: 1, // 1-上传 2-解析,
			oneMinutesTimer: null, //30s计时器
			analyseSetp1Countdown: 60, // 解析第一步倒计时60s
			analyseSetp1Timer: null  // 60s倒计时计时器
		}
	},
	computed: {
		traceOuterShowTip() {
			return this.pcbParams.lineweight + '/' + this.pcbParams.lineweight != this.resoveData.dMinLineWidth + '/' + this.resoveData.dMinLineDist
		},
		loginInfo(){
			return this.$store.getters.getLoginInfo;
		},
		bcount(){
			return this.pcbParams.bcount || 0
		},
		// 是否是从dfm跳转
		isFromDfm(){
			return window.location.href.includes('isDfm=1') || false
		},
		newDfmUrl(){
			// let url='http://www.dfmviewer.com:3001'
			let url= process.env.VUE_APP_HOST+'/free-online-gerber-viewer.html'
			const stay = this.$store.state.quote.stay
			const pageMap={
				pcb:1,
				smt:2,
				smd:3
			}
		 const pageType=pageMap[stay]
			if(this.analyseId){
				this.$store.commit("setAnalyseId",this.analyseId)
				return `${url}?aid=${this.analyseId}&name=${this.fileData.name}&page=${pageType}${this.bcount?'&count='+this.bcount:''}`
			}
			else{
				return url+'?page='+pageType
			}
		},
		isInDFM(){
			if(window.isInDFM){
				return JSON.parse(window.isInDFM)
			}
			else{
				return false
			}
		},
		// dfm软件传递的计价
		dfmQuoteData(){
			return this.$store.state.quote.ajaxQuoteParams
		},
		currentStay(){
			return this.$store.state.quote.stay
		},
		isChangeType(){
			return this.$store.state.isChangeType
		},
		pageData(){
			return this.$store.state.pcbPageData
		},
		isChangeParams() {
			return this.$store.state.isChangeParams
		},
		changeParams() {
			return this.$store.state.changeParams
		}
	},
	watch:{
		dfmQuoteData:{
			immediate: true,
			handler(v){
				if(this.$route.query.quoteid && v){
					if(!v.fid){
						return false
					}
					this.percentage = 0
					this.resoveCount = 0
					this.nextUpPercent = false
					this.file_list=[{key: 0, name: v.file_name}]
					this.fileData={
						fid: v.fid,
						name: v.file_name,
						size: Math.ceil(v.file_size/1024),
						url: v.file_path
					}
					// 处理拼版解析的
					if(v.units==3){
						v.oneOrMoreBoard='多板'
					}
					if(v.simulimagetop){
						this.resolveImg.top = v.simulimagetop
					}
					if(v.simulimagebot){
						this.resolveImg.bot = v.simulimagebot
					}
					// v.lineweightReal = v.lineweight

					// v.lineweight = this.dLineweight(v.lineweight)

					v.lineweightReal = v.lineweight + '/' +  v.lineweight

					v.lineweight = this.countLineweight(v.lineweight)

					if(v.bankong+'' === '0') {
						v.bankong = ''
					}

					// if(v.blayer == 1){
					// 	if([3.5,4].includes(v.lineweight)){
					// 		v.lineweight = 5
					// 	}
					// }else if(v.blayer == 2){
					// 	if([3.5].includes(v.lineweight)){
					// 		v.lineweight = 4
					// 	}
					// }

					this.resoveData={...v, dpcsLength: v.blength, dpcsWidth: v.bwidth}
					this.isResove = true
					if(this.$refs.npupFile2){
						this.$refs.npupFile2.clearFile("all");
					}
					this.$emit("resolveGerberSuccess",v);
					this.$emit("getfid",v.fid,this.fileData);
				}
			}
		},
		$data:{
			handler(v){
				if(!this.isChangeType){
					this.$store.commit('setPcbPageData',v)
				}
			},
			deep: true,
			immediate: true
		},
		changeParams: {
			handler(v) {
				const { gerber_file, gerber_file_id } = v
				const name = gerber_file.substr(gerber_file.lastIndexOf('/')+1)
				this.fileData = { fid: gerber_file_id, name, url: gerber_file }
				this.$emit("getfid", gerber_file_id, this.fileData);
			},
			deep: true
		}
	},
	mounted(){	
		console.log('pcb_ur**********',this.isChangeParams, this.changeParams)
		this.$nextTick(()=>{
			if(this.isChangeType){
				console.log('is ChangeType--mounted---',this.isChangeType)
				for(let key of Object.keys(this.pageData)){
					// this[key] = this.pageData[key]
					this.$set(this,key,JSON.parse(JSON.stringify(this.pageData[key])))
					console.log(key+'=',JSON.parse(JSON.stringify(this.pageData[key])))
				}
				if(this.isResove){
					this.params = this.fileData
					this.params.fileName = this.fileData.name
					// this.handleAnalyseData()
				}
				if(this.currentStay == 'smt'){
					console.log('set pcba number--**--**')
					this.$store.commit("setQuoteParams",{value:this.pcbParams.bcount,key:"smt_params.number"});
				}
				this.$store.commit('setChangeType', false)
			}
		})
		
		if(this.$route.query.kicadid||this.$tools.getUrlParams("kicadid")){
			this.handleEdaParams()
			// const searchParams = new URLSearchParams(window.location.href)
			// this.kicadid = this.$route.query.kicadid || this.$tools.getUrlParams("kicadid");
			// this.fid = window.kicadid || searchParams.get('gerber_file_id');
			// const url = window.GERBER_URL || this.$route.query['gerber_file']
			// this.$store.commit("setQuoteParams",{value: this.fid, key:"aside_param.gerber_file_id"});
			// this.$store.commit("setQuoteParams",{value: url, key:"aside_param.gerber_file"});
			// this.resolveZip(this.fid,true);	
			// const name = url.substr(url.lastIndexOf('/')+1)
			// if(this.fid && url){
			// 	console.log('kicadid***----',this.fid, url)
			// 	this.fileData={ fid: this.fid, name, size: 'unknow', url }
			// 	this.isfileUp =true
			// 	this.percentage = 50	
			// 	this.params.fileName = name
			// 	this.params.size = 'unknow'
			// 	this.resoveData.file_path = url
			// 	this.file_list=[{key: 0, name}]
			// 	this.actionStatus = 2
			// 	this.newDfmResolve({fid: this.fid, url, name})
			// }
		}

		if(this.$route.query.librepcbid || this.$route.query.appid){
			// this.kicadid = this.$route.query.librepcbid;
			this.fid = window.GERBER_FILE_ID || this.$route.query['gerber_file_id']
			const url = window.GERBER_URL || this.$route.query['gerber_file']
			this.$store.commit("setQuoteParams",{ value: this.fid, key: "aside_param.gerber_file_id" });
			this.$store.commit("setQuoteParams", {value: url, key: "aside_param.gerber_file" });
			// this.resolveZip(this.fid,true);
			// 新版DFM解析
			const name = url.substr(url.lastIndexOf('/')+1)
			if(this.fid && url){
				console.log('librepcbid----',this.fid, url)
				this.fileData={ fid: this.fid, name, size: 'unknow', url }
				this.isfileUp =true
				this.percentage = 50	
				this.params.fileName = name
				this.params.size = 'unknow'
				this.resoveData.file_path = url
				this.file_list=[{key: 0, name}]
				this.actionStatus = 2
				this.newDfmResolve({fid: this.fid, url, name})
			}
		}

		// 清空过期的pcb计价数据
		this.handleClearExpireData()

		// 只是从dfm计价后跳转的 从dfm解析页面跳转过来，回显解析文件的数据
		setTimeout(() => {
			const analyseId=this.$route.query.aid
			const nextdfmData = window.localStorage.getItem('nextdfm'+analyseId)
			if(!nextdfmData){
				return false
			}
			const nextdfmParams = JSON.parse(window.localStorage.getItem('nextdfm'+analyseId)).params
			console.log(232, nextdfmParams,this.isFromDfm)
			if(this.isFromDfm && nextdfmParams) {
				const hanleParamsData = {
					iLayers: nextdfmParams.blayer,
					dpcsWidth:  this.$tools.keepDecimal(nextdfmParams.bwidth * 10, 1),
					dpcsLength:  this.$tools.keepDecimal(nextdfmParams.blength * 10, 1),
					dMinDrill: nextdfmParams.vias,
					dMinLineWidth: nextdfmParams.lineweight,
					dMinLineDist: nextdfmParams.lineweight,
					bcount: nextdfmParams.bcount,
					iDrillCount: nextdfmParams?.zknum,
					goldAreaRate: nextdfmParams?.cjarea,
					viaInPad: nextdfmParams?.via_in_pad || 'N/A',
					viaOnSmdPad: nextdfmParams?.via_on_smd_pad || 'N/A',
					testPoint: nextdfmParams?.testpoint || 0,
					file_path: nextdfmParams.gerber_file,
					units: nextdfmParams.units,
					padWidth: nextdfmParams.pad_width || '',
					lineweightInit: nextdfmParams.lineweightInit || (nextdfmParams.lineweight + '/' + nextdfmParams.lineweight),
					viasInit: nextdfmParams.viasInit || nextdfmParams.vias
				}

				this.resolveImg = nextdfmParams.resolveImg || {}
				 
				let hanleParams = {
					key: 0,
					data: hanleParamsData,
					file_list: [{
						key: 0,
						name: nextdfmParams.file_name,
					}]
				}
				this.fid = nextdfmParams.gerber_file_id
				this.fileData = {
					fid: nextdfmParams.gerber_file_id,
					name: nextdfmParams.file_name,
					size: Math.ceil(nextdfmParams.file_size/1024),
					url: nextdfmParams.gerber_file
				}
				this.$set(this.params,"size",Math.ceil(nextdfmParams.file_size/1024));
				//Gerberview文件上传后提交参数到计价参数
				this.$store.commit("setQuoteParams",{value:this.fid,key:"aside_param.gerber_file_id"});
				this.$store.commit("setQuoteParams",{value:this.fileData.url,key:"aside_param.gerber_file"});
				this.isResove = true
				this.resolveSuccess(hanleParams,this.fid);
			}	
		}, 0)
	
		this.initChangeParams()
	},
	methods:{
		getfiles(files){			
			this.$set(this.params,"fileName",files[0].name);
			this.$set(this.params,"size",Math.ceil(files[0].size/1024));
		},
		upfileProgress(arg){
			//监听文件上传进度
			let complete = arg.process;
				this.nextUpPercent = true;
				if(!this.percentage && arg.isend) return;
				this.percentage = Math.ceil(complete);
		},
		fileupsuccess(rst){
			if(!this.percentage) return;
			//文件上传成功 			
			this.fid = rst.res.fid;	
			this.fileData = rst.res;
			//Gerberview文件上传后提交参数到计价参数
			this.$store.commit("setQuoteParams",{value:rst.res.fid,key:"aside_param.gerber_file_id"});
			this.$store.commit("setQuoteParams",{value:rst.res.url,key:"aside_param.gerber_file"});
			console.log(251, rst,this.$store.getters.getQuoteAsideParams)
			// this.resolveZip(rst.res.fid);
			
			this.actionStatus = 2
			// 新版DFM解析
			this.newDfmResolve(rst.res)
		},
		clearFiles(){
			try{
				this.$refs.npupFile.clearFile("all");
				this.isCannotResolved = false;
				
				this.analyseId=null
				this.actionStatus = 1
				this.fileData ={}
				this.analyzingTip = 'Analyzing..'
				if(this.isChangeParams) {
					this.$store.commit('setGerberFileIsChange', 1)
				}
			}catch(e){
				//TODO handle the exception
			}
			this.$store.commit("setQuoteParams",{value:"",key:"aside_param.gerber_file_id"});
			this.$store.commit("setQuoteParams",{value:"",key:"aside_param.gerber_file"});		
		},
		clearFileYes(e){
			if(e){ //清除成功
				this.params.fileName = "";
				this.params.size = "";
				this.percentage = 0;
				// this.resolveImg ={}
				this.$store.commit("setQuoteParams",{value:"",key:"aside_param.gerber_file_id"});
				this.$store.commit("setQuoteParams",{value:"",key:"aside_param.gerber_file"});		
				clearTimeout(this.resolveIdx);
				clearInterval(this.interId);
				
				clearTimeout(this.analyseTimer)
			}
		},
		dLineweight: function(i){
			var d;
			if (i == ''){
				d = i
			} else if( i <= 3.5 || i > 3.5 && i < 4 ){
				d = 3.5;
			}else if (i >= 4 && i < 5) {
				d = 4;
			}else if (i >= 5 && i < 6) {
				d = 5;
			}else if (i >= 6 && i < 7 ) {
				d = 6;
			}
			else if (i > 10){
				i = 10
			}
			else {
				d = i
			}
			return d;
		},
		dMinDrill: function(i){
			var d;
			if (i < 0.2) {
				d = 0.15;
			}else if (i >= 0.2 && i < 0.25) {
				d = 0.2;
			}else if (i >= 0.25 && i < 0.3) {
				d = 0.25;
			}else if (i >= 0.3) {
				d = 0.3;
			}
			return d;
		},
		dLayers: function(i){
			var d;
			if( i > 1 && i%2 == 1 ){
				if( i > 12 ){
					d = 12;
				}else{
					d = i = i/1 + 1;
				}
			}else {
				if( i < 2 ){
					d = 2;
				}else {
					d = i;
				}
			}
			return d;
		},
		resolveZip(fid,iskidcard){
			var vm = this;
			vm.resoveCount++;
			vm.isCannotResolved = false
			this.$http.post(this.$api.fileAnalysisData,{
				fid
			}).then(function(res){
				// let  res= {"code":"200","msg":"success","data":{"auditResult":"1","botImage":"https://camfile.nextpcb.com/gerber//2023-04-21/298809_1/298809_gbr_1_bot.png","dDrlDistance":"正常","dDrlLineDistance":"0.298","dMaxDrill":"3.734","dMinDrill":"0.356","dMinLineDist":"正常","dMinLineWidth":"正常","dPadWidth":"","dpcsLength":"95.354","dpcsWidth":"110.353","gbrNameList":"Panel_Profile.gbr.zip??Single Board With Heater Trace_Copper_Signal_Bot.gbr.zip??Single Board With Heater Trace_Copper_Signal_Top.gbr.zip??Single Board With Heater Trace_Drawing_1.gbr.zip??Single Board With Heater Trace_Drillmap_1.gbr.zip??Single Board With Heater Trace_DXF_Import.gbr.zip??Single Board With Heater Trace_Legend_Top.gbr.zip??Single Board With Heater Trace_NPTH_Drill.gbr.zip??Single Board With Heater Trace_Paste_Top.gbr.zip??Single Board With Heater Trace_PTH_Drill.gbr.zip??Single Board With Heater Trace_Route_Tool_Path.gbr.zip??Single Board With Heater Trace_Soldermask_Bot.gbr.zip??Single Board With Heater Trace_Soldermask_Top.gbr.zip??Single Board With Heater Trace_Top_Assembly.gbr.zip??Single Board With Heater Trace_V_Score_Lines.gbr.zip??FF-0302910500-AB-NonPlated.TXT.zip??FF-0302910500-AB-Plated.TXT.zip","gbrPath":"https://camfile.nextpcb.com/gerber//2023-04-21/298809_1","goldAreaRate":"77.936","iDrillCount":"1402","iLayers":"5","imagePath":"","isBlindHole":"","isHalfHole":"","isMultiBoard":"","layerImageInfo":[{"imagePath":"https://camfile.nextpcb.com/gerber//2023-04-21/298809_1/Single Board With Heater Trace_Legend_Top.gbr.png","name":"gto","old_name":"Single Board With Heater Trace_Legend_Top.gbr","side":"顶层","type":"丝印"},{"imagePath":"https://camfile.nextpcb.com/gerber//2023-04-21/298809_1/Single Board With Heater Trace_Soldermask_Top.gbr.png","name":"gts","old_name":"Single Board With Heater Trace_Soldermask_Top.gbr","side":"顶层","type":"阻焊"},{"imagePath":"https://camfile.nextpcb.com/gerber//2023-04-21/298809_1/Single Board With Heater Trace_Copper_Signal_Top.gbr.png","name":"gtl","old_name":"Single Board With Heater Trace_Copper_Signal_Top.gbr","side":"顶层","type":"线路"},{"imagePath":"https://camfile.nextpcb.com/gerber//2023-04-21/298809_1/Single Board With Heater Trace_DXF_Import.gbr.png","name":"Single Board With Heater Trace_DXF_Import.gbr","old_name":"Single Board With Heater Trace_DXF_Import.gbr","side":"其他","type":"线路"},{"imagePath":"https://camfile.nextpcb.com/gerber//2023-04-21/298809_1/Single Board With Heater Trace_Route_Tool_Path.gbr.png","name":"Single Board With Heater Trace_Route_Tool_Path.gbr","old_name":"Single Board With Heater Trace_Route_Tool_Path.gbr","side":"其他","type":"线路"},{"imagePath":"https://camfile.nextpcb.com/gerber//2023-04-21/298809_1/Single Board With Heater Trace_V_Score_Lines.gbr.png","name":"Single Board With Heater Trace_V_Score_Lines.gbr","old_name":"Single Board With Heater Trace_V_Score_Lines.gbr","side":"其他","type":"线路"},{"imagePath":"https://camfile.nextpcb.com/gerber//2023-04-21/298809_1/Single Board With Heater Trace_Copper_Signal_Bot.gbr.png","name":"gbl","old_name":"Single Board With Heater Trace_Copper_Signal_Bot.gbr","side":"底层","type":"线路"},{"imagePath":"https://camfile.nextpcb.com/gerber//2023-04-21/298809_1/Single Board With Heater Trace_Soldermask_Bot.gbr.png","name":"gbs","old_name":"Single Board With Heater Trace_Soldermask_Bot.gbr","side":"底层","type":"阻焊"},{"imagePath":"https://camfile.nextpcb.com/gerber//2023-04-21/298809_1/FF-0302910500-AB-Plated.TXT.png","name":"drl3","old_name":"FF-0302910500-AB-Plated.TXT","side":"其他","type":"钻孔"},{"imagePath":"https://camfile.nextpcb.com/gerber//2023-04-21/298809_1/FF-0302910500-AB-NonPlated.TXT.png","name":"drl2","old_name":"FF-0302910500-AB-NonPlated.TXT","side":"其他","type":"钻孔"},{"imagePath":"https://camfile.nextpcb.com/gerber//2023-04-21/298809_1/Single Board With Heater Trace_PTH_Drill.gbr.png","name":"drl1","old_name":"Single Board With Heater Trace_PTH_Drill.gbr","side":"其他","type":"钻孔"},{"imagePath":"https://camfile.nextpcb.com/gerber//2023-04-21/298809_1/Single Board With Heater Trace_NPTH_Drill.gbr.png","name":"drl","old_name":"Single Board With Heater Trace_NPTH_Drill.gbr","side":"顶底层","type":"钻孔"},{"imagePath":"https://camfile.nextpcb.com/gerber//2023-04-21/298809_1/Panel_Profile.gbr.png","name":"gko","old_name":"Panel_Profile.gbr","side":"顶底层","type":"外形"},{"imagePath":"https://camfile.nextpcb.com/gerber//2023-04-21/298809_1/Single Board With Heater Trace_Paste_Top.gbr.png","name":"gtp","old_name":"Single Board With Heater Trace_Paste_Top.gbr","side":"其他","type":"其他"},{"imagePath":"https://camfile.nextpcb.com/gerber//2023-04-21/298809_1/Single Board With Heater Trace_Drillmap_1.gbr.png","name":"gdd-1","old_name":"Single Board With Heater Trace_Drillmap_1.gbr","side":"其他","type":"其他"},{"imagePath":"https://camfile.nextpcb.com/gerber//2023-04-21/298809_1/Single Board With Heater Trace_Top_Assembly.gbr.png","name":"Single Board With Heater Trace_Top_Assembly.gbr","old_name":"Single Board With Heater Trace_Top_Assembly.gbr","side":"其他","type":"其他"},{"imagePath":"https://camfile.nextpcb.com/gerber//2023-04-21/298809_1/Single Board With Heater Trace_Drawing_1.gbr.png","name":"gdd","old_name":"Single Board With Heater Trace_Drawing_1.gbr","side":"其他","type":"其他"}],"remark":"层命名可能不正确，请查看","resultPath":"https://camfile.nextpcb.com/gerber//2023-04-21/298809_1/298809_gbr_1.json.zip","silkBlockStatus":"0","testPoint":"1108","topImage":"https://camfile.nextpcb.com/gerber//2023-04-21/298809_1/298809_gbr_1_top.png","uniqueKey":"298809_gbr_1","unitTravel":"80.854"},"file_list":[{"name":"FF0302910500ABProductionFilesUBoardSingle_1.zip","key":0,"auditResult":1}],"key":0};
				if(res.code == 200){
					//解析成功
					vm.isResove = true;
					vm.percentage = 100;
					vm.nextUpPercent = true;
					clearInterval(vm.interId);
					clearTimeout(vm.resolveIdx);
					//解析成功函数
					vm.resolveSuccess(res,fid,iskidcard);
				}else{
					if(!iskidcard){
						if(!vm.percentage) return;
					}
					//解析失败 继续请求解析
					let counts = iskidcard?30:10;
					//res.code != 102 &&
					if(res.code != 102 && vm.resoveCount < counts ) {						
						vm.resolveIdx = setTimeout(function(){
							vm.resolveZip(fid,iskidcard);
							vm.percentage += vm.$tools.keepDecimal(50/(counts - 1),0,true) ;							
							if(vm.percentage>=99){
								vm.percentage = 99;
							}
						},iskidcard?3500:10000);
					}else{
						//vm.percentage = 0;
						clearTimeout(vm.resolveIdx);
						clearInterval(vm.interId);
						vm.showUpbtn = true;
						vm.percentage = 0;
						vm.resoveCount = 0;
						vm.nextUpPercent = false;
						// vm.clearFiles();
						vm.$alert.msg(res.msg);
						vm.$emit("getfid",fid,vm.fileData); // 文件数据传回计价页面
						vm.isCannotResolved = true // 显示文件无法解析提示
						//解析失败事件
						vm.$emit("resolveGerberFailed",res);

						// 谷歌ga4事件跟踪
						try {
							const stay = vm.$store.state.quote.stay
							const eventName=stay==='pcb'?'pcbgerberfailed':'pcbagerberfailed'
							window.dataLayer.push({event:eventName})
						} catch (error) {
							console.error(error)
						}
						
					}
				}
			});
		},
		resolveSuccess(res,fid,iskidcard){
			this.percentage = 0;
			this.resoveCount = 0;
			this.nextUpPercent = false;
			//res数组 解析成功
			this.key = res.key;
			this.file_list = res.file_list;
			this.resoveData = res.data;
			let data = res.data;
			let tmp = {};
				tmp.blayer = data.iLayers
				tmp.initBlayer = data.iLayers // 记录解析出来原始的层数值
				tmp.bwidth = (data.dpcsWidth/1).toFixed(1);
				tmp.blength = (data.dpcsLength/1).toFixed(1);
				tmp.vias = data.dMinDrill// this.countVias(data.dMinDrill); // 最小孔
				tmp.initVias = data.viasInit // 记录解析出来原始的最小孔值
				tmp.lineweight = data.dMinLineWidth //this.countLineweight(data.dMinLineWidth)
				tmp.lineweightReal = data.lineweightInit
				if(data.bcount) tmp.bcount = data.bcount // dfm解析跳转过来会有默认数量5
				// tmp.oneOrMoreBoard = data.oneOrMoreBoard // 单板或多板
				tmp.oneOrMoreBoard = data.units == 3 ? '多板' : '单板'
				tmp.units = data.units
				tmp.testpoint = data.testPoint || 0 // 测试点数
				tmp.zknum = data.iDrillCount || 0 // 孔密度
				tmp.cjarea = data.goldAreaRate ? Number(data.goldAreaRate).toFixed(2) : 0 // 沉金面积
				tmp.via_in_pad = data.viaInPad // 盘中孔
				tmp.via_on_smd_pad = data.viaOnSmdPad // 盘中孔
				tmp.pad_width = data.padWidth // 焊盘宽度

				tmp.luoNum =  data.luoNum || 0 // 锣长分析值
				tmp.bankong = data.bankong || ''
				tmp.blind = data.blind || ''

			// if(tmp.blayer == 1){
			// 	if([3.5,4].includes(tmp.lineweight)){
			// 		tmp.lineweight = 5
			// 	}
			// }else if(tmp.blayer == 2){
			// 	if([3.5].includes(tmp.lineweight)){
			// 		tmp.lineweight = 4
			// 	}
			// }
			
			if (tmp.pad_width == 'No errors detected') {
				tmp.pad_width = '0.25'
			}
			//清除上传组件状态
			if(this.$refs.npupFile2){
				this.$refs.npupFile2.clearFile("all");
			}
			console.log('resolveGerberSuccess*****', tmp)
			this.$emit("resolveGerberSuccess",tmp, iskidcard);
			this.$emit("getfid",fid,this.fileData);
		},
		alertHelp(e,key,width){
			//彈出提示層
			width = width || '230px';
			if(!this.LANG[key]) return;
			this.$alert.dialog({
				content: this.LANG[key] ,
				style: "max-width:"+width+";"
			},e)
		},
		comfiles(e){
			if(e && e.length){
				this.isfileUp = true;
			}else{
				this.isfileUp = false;
			}
		},
		handleGoDfm(e){
			if(e.preventDefault) e.preventDefault();
			
			// 上传中
			if(!this.fid && this.percentage > 0 ){
				return false
			}

			// 解析中
			if(!this.isResove && !this.isCannotResolved && this.fid){
				this.$alert.msg(this.LANG.analysing_tip);
				return false	
			}
			window.open(this.newDfmUrl)
		},
		/* 新版dfm在线解析 bgn */
		async newDfmResolve(uploadInfo){
			this.analyseId = await this.getAnalyseIdByPath(uploadInfo)
			if(!this.analyseId){
				return false
			}
			this.getAnalyseSvgData()
			setTimeout(()=>{
				this.analyzingTip = 'Please wait a moment. Larger and more complex designs may take longer to analyze.'
			},1000 * 5)
		},
		// 根据文件路径获取分析ID
    getAnalyseIdByPath(uploadInfo) {
			return new Promise((resolve,reject)=>{
				const { fid, url, name } = uploadInfo
				const newUrl = process.env.VUE_APP_HOST + url
				this.$http
					.post(
						this.$api.uploadDfmFile,
						{ fid, url: newUrl, name },
					)
					.then((res) => {
						if (res.response_code === '2000') {
							resolve(res.response_data.analyse_id)
						}
						else {
							reject(null)
						}
					})
			})  
    },
		// 获取svg解析图片
		getAnalyseSvgData(){
			// 第一步超过1分钟后提示语变更
			if(!this.oneMinutesTimer){
				this.oneMinutesTimer= setTimeout(()=>{
					this.analyzingTip = 'Actively analyzing your file in '
					if(this.analyseSetp1Timer) {
						return false
					}
					this.analyseSetp1Countdown--
					this.analyseSetp1Timer = setInterval(() => {
						this.analyseSetp1Countdown--
					}, 1000);
				}, 1000 * 30 )
			}
			
			
			const params = {}
      // eslint-disable-next-line
      params.analyse_id = this.analyseId
			this.$http({methods:'get',url:this.$api.analyseResult, params})
        .then((res) => {
          if (res.code === 22006 && this.analyseSetp1Countdown > 0) {
            this.analyseTimer = setTimeout(() => {
              this.getAnalyseSvgData()
							this.percentage += 2
							if(this.percentage>=70){
								this.percentage = 70
							}
            }, 3000)
          } else if (Number(res.response_code) === 2000) {
						this.resolveImg.top = res.response_data.simulimagetop
						this.resolveImg.bot = res.response_data.simulimagebot

            if (res.response_data.layer_info.length > 0) {
							// svg解析成功
							this.percentage=70
							this.getAnalyseOrderParams()
              // 谷歌Ga4事件
              window.dataLayer.push({
                event: 'PCBImageParsedSuccess',
              })
            }
            clearTimeout(this.analyseTimer)
						clearInterval(this.analyseSetp1Timer)
						clearTimeout(this.oneMinutesTimer)
						this.oneMinutesTimer = null
						this.analyseSetp1Timer = null
						this.analyseSetp1Countdown = 60
						this.analyzingTip = 'Please wait a moment. Larger and more complex designs may take longer to analyze.'
          } else {
            // 解析异常
						this.showUpbtn = true;
						this.percentage = 0;
						this.resoveCount = 0;
						this.nextUpPercent = false;
						this.actionStatus = 1

						clearInterval(this.analyseSetp1Timer)
						clearTimeout(this.oneMinutesTimer)
						this.oneMinutesTimer = null
						this.analyseSetp1Timer = null
						this.analyseSetp1Countdown = 60

						// this.$alert.msg(res.msg);
						this.$alert.toast(res.msg,{type:"warning",style:{top:'45%'}}, 3000)
						this.$emit("getfid",this.fid,this.fileData); // 文件数据传回计价页面
						this.isCannotResolved = true // 显示文件无法解析提示
						//解析失败事件
						this.$emit("resolveGerberFailed");

						// 谷歌ga4事件跟踪
						try {
							const stay = this.$store.state.quote.stay
							const eventName=stay==='pcb'?'pcbgerberfailed':'pcbagerberfailed'
							window.dataLayer.push({event:eventName})
						} catch (error) {
							console.error(error)
						}
          }
        })
		},
		// 获取新版dfm解析的文件参数
		getAnalyseOrderParams() {
      const params = { id: this.analyseId }
			
			this.resoveCount++

      this.$http({ url: this.$api.orderParams, method: 'get', params })
        .then((res) => {
          if (Number(res.code) === 22006) {
						if(this.resoveCount > 9){
							this.showUpbtn = true;
							this.percentage = 0;
							this.resoveCount = 0;
							this.nextUpPercent = false;
							this.actionStatus = 1

							// this.$alert.msg(res.msg);
							this.$alert.toast(res.msg,{type:"warning",style:{top:'45%'}}, 3000)
							this.$emit("getfid",this.fid,this.fileData); // 文件数据传回计价页面
							this.isCannotResolved = true // 显示文件无法解析提示
							//解析失败事件
							this.$emit("resolveGerberFailed",res);
							
							return false
						}
            this.analyseTimer = setTimeout(() => {
              this.getAnalyseOrderParams()
							this.percentage += 2
							if(this.percentage>=99){
								this.percentage = 99
							}
            }, 3000)
          } else if (Number(res.response_code) === 2000) {
            this.analyseOrderParams = res.response_data.order_params
            this.analyseQuoteParams = res.response_data.quote_params
            
						
						//解析成功
						this.isResove = true;
						this.percentage = 100;
						this.nextUpPercent = true;

						//解析成功函数
						this.handleAnalyseData()

						this.$store.commit('setAnalyzeSuccess', 1)
						
            
						// 谷歌Ga4事件
            window.dataLayer.push({
              event: 'PCBParameterParsedSuccess'
            })
          } else {
            this.showUpbtn = true;
						this.percentage = 0;
						this.resoveCount = 0;
						this.nextUpPercent = false;
						this.actionStatus = 1

						// this.$alert.msg(res.msg);
						this.$alert.toast(res.msg,{type:"warning",style:{top:'45%'}}, 3000)
						this.$emit("getfid",this.fid,this.fileData); // 文件数据传回计价页面
						this.isCannotResolved = true // 显示文件无法解析提示
						//解析失败事件
						this.$emit("resolveGerberFailed",res);

						// 谷歌ga4事件跟踪
						try {
							const stay = this.$store.state.quote.stay
							const eventName=stay==='pcb'?'pcbgerberfailed':'pcbagerberfailed'
							window.dataLayer.push({event:eventName})
						} catch (error) {
							console.error(error)
						}
          }
        })
        .catch((e) => {
					console.error(e)
          this.showUpbtn = true;
					this.percentage = 0;
					this.resoveCount = 0;
					this.nextUpPercent = false;
					this.actionStatus = 1

					// vm.$alert.msg(res.msg);
					this.$emit("getfid",this.fid,this.fileData); // 文件数据传回计价页面
					this.isCannotResolved = true // 显示文件无法解析提示
					//解析失败事件
					// this.$emit("resolveGerberFailed",res);

					// 谷歌ga4事件跟踪
					try {
						const stay = this.$store.state.quote.stay
						const eventName=stay==='pcb'?'pcbgerberfailed':'pcbagerberfailed'
						window.dataLayer.push({event:eventName})
					} catch (error) {
						console.error(error)
					}
        })
    },
		handleAnalyseData(){
			const { blayer, bwidth, blength, testpoint, units, pad_width, bankong, blind } = this.analyseQuoteParams
			
			// 孔密度
      const dirllHodeDensityObj=this.analyseOrderParams.pcb_specs.find(item=>item.name==='孔密度'||item.english_name.includes('Drill Hole Densit'))
      const zknum=dirllHodeDensityObj&&dirllHodeDensityObj?.display.split(';')[0].replace('PCS','').replace('pcs').match(/\d+/)[0] || 0
      
      // 沉金面积
      const cjAreaObj=this.analyseOrderParams.pcb_specs.find(item=>item.name==='沉金面积'||item.english_name.includes('Surface Finish Area'))
      const cjarea=cjAreaObj?.display.replace('%','') || 0
      // 盘中孔
      const viaInPadObj=this.analyseOrderParams.dfm_checklist.find(item=>item.name==='孔上焊盘'||item.english_name.includes('Holes on SMD Pads'))
      // const viaInPad=viaInPadObj &&  !['No errors detected', 'Normal'].includes(viaInPadObj?.display)? '1': 'N/A' || 'N/A'
			let viaInPad = 'N/A', viaOnSmdPad = 'N/A'
			if(viaInPadObj){
				// if(this.currentStay == 'smt' && (viaInPadObj['via-in-pad'] == 'Have' || viaInPadObj['via-on-smd-pad'] == 'Have')){
				// 	viaInPad='Have'
				// }
				if(viaInPadObj['via-on-smd-pad'] == 'Have'){
					viaOnSmdPad = 'Have'
				}
				if(viaInPadObj['via-in-pad'] == 'Have'){
					viaInPad='Have'
				}
			}

			// 锣长分析值
			let luo,luoNum = 0
			try {
				luo = this.analyseOrderParams.pcb_specs.find(item=>item.name==='锣长分析'||item.english_name.includes('Milling Density'))
      	if(luo && luo.display) {
					const match =  luo.display.match(/(\d+(\.\d+)?)/)
					luoNum = match ? match[0] : 0
				}
			} catch(e) {
				console.log(e)
			}

			// 最小线宽
			let linewidth, linewidthValue;
			try {
				linewidth = this.analyseOrderParams.pcb_parameters.find(item => item.name == '最小线宽' || item.english_name.includes('Smallest Trace Width')) 
				if(linewidth) {
					if (linewidth?.display_inch !== 'No errors detected') {
						const match = linewidth?.display_inch.match(/(\d+(\.\d+)?)/)
						linewidthValue = match ? match[0] : 0
					} else {
						linewidthValue = 10
					}
				}
			} catch(e) {
				console.log(e)
			}

			// 最小间距
			let linespace, linespaceValue;
			try {
				linespace = this.analyseOrderParams.pcb_parameters.find(item => item.name == '最小间距' || item.english_name.includes('Smallest Trace Spacing')) 
				if(linespace) {
					if (linespace?.display_inch !== 'No errors detected') {
						const match = linespace?.display_inch.match(/(\d+(\.\d+)?)/)
						linespaceValue = match ? match[0] : 0
					} else {
						linespaceValue = 10
					}
				}
			} catch(e) {
				console.log(e)
			}

			const lineweightNew = Number(Math.min(linewidthValue, linespaceValue))

			// 最小孔
			let viasObj, vias;
			try {
				viasObj = this.analyseOrderParams.pcb_parameters.find(item => item.name == '孔大小' || item.english_name.includes('Drill/Slot Size')) 
				if(viasObj) {
					const match = viasObj?.display.match(/(\d+(\.\d+)?)/)
					vias = match ? Number(match[0]) : 0
				}
			} catch(e) {
				console.log(e)
			}

      
			const paramsData={
				iLayers: blayer,
				dpcsWidth:  this.$tools.keepDecimal(bwidth * 10, 1),
				dpcsLength:  this.$tools.keepDecimal(blength * 10, 1),
				dMinDrill: this.countVias(vias),
				dMinLineWidth: this.countLineweight(lineweightNew),
				dMinLineDist: this.countLineweight(lineweightNew),
				iDrillCount: zknum,
				goldAreaRate: cjarea,
				viaInPad: viaInPad,
				viaOnSmdPad,
				testPoint: testpoint,
				file_path: this.fileData.url,
				units,
				padWidth: pad_width,
				luoNum,
				bankong,
				blind,
				lineweightInit: linewidthValue+'/'+linespaceValue,
				viasInit: vias
			}

			let resData = {
				key: 0,
				data: paramsData,
				file_list: [{
					key: 0,
					name: this.params.fileName,
				}]
			}
			console.log('handleAnalyseData',resData)
			this.resolveSuccess(resData,this.fid);
		},
		// 删除过期的dfm计价参数
    handleClearExpireData(){
      const nowTime=Math.round(new Date().getTime()/1000)
      const dfmData=[]
      for(const key in window.localStorage){
        if(key.includes('nextpcb')){
          const temp={
            key,data:JSON.parse(window.localStorage.getItem(key))
          }
          dfmData.push(temp)
        }
      }
      const expireData = dfmData.filter(item => item.data.expireTime < nowTime)
      expireData.forEach(item=>{
        window.localStorage.removeItem(item.key)
      })
    },
		// 处理EDA跳转的参数
		handleEdaParams(){
			const params = this.$route.query
			this.fid = params.gerber_file_id || window.kicadid || window.GERBER_FILE_ID
			const url = params.gerber_file || window.GERBER_URL

			this.$store.commit("setQuoteParams",{value: this.fid, key:"aside_param.gerber_file_id"});
			this.$store.commit("setQuoteParams",{value: url, key:"aside_param.gerber_file"});

			const name = url.substr(url.lastIndexOf('/')+1)

			if(!this.fid && url){
				return false
			}
			this.percentage = 0
			this.resoveCount = 0
			this.nextUpPercent = false
			this.file_list=[{key: 0, name: name}]
			this.fileData={ fid: this.fid, name, size: 'unknow', url }
			this.isfileUp =true
			this.params.fileName = name
			this.params.size = 'unknow'
			this.resoveData.file_path = url
			this.file_list=[{key: 0, name}]

			this.resoveData={...params, dpcsLength: params.blength, dpcsWidth: params.bwidth, file_path:url}
			this.isResove = true
			if(this.$refs.npupFile2){
				this.$refs.npupFile2.clearFile("all");
			}
			this.$emit("resolveGerberSuccess",params, true);
			this.$emit("getfid",this.fid,this.fileData);
		},
		// 修改参数量
		initChangeParams(){
			if (this.isChangeParams) {
				this.isResove = false
				this.isfileUp = true
				this.isCannotResolved = true

				// this.fileData = { fid: 1123231, name: 'textasd.zip', size: 'unknow', url: this.changeParams.pcbfile }
				console.log('initChangeParams', this.fileData)
				//解析失败事件
				this.$emit("resolveGerberFailed");
			}
		},
		countLineweight(num) {
			const minValue = Math.floor(num)
			console.log('countLineweight***-*-', num, minValue)
			if(minValue === 0) return 6;
			else if (minValue < 3.5) return 3.5;
			else if (minValue >= 3.5 && minValue < 4) return 3.5;
			else if (minValue >= 4 && minValue < 5) return 4;
			else if (minValue >= 5 && minValue < 6) return 5;
			else if (minValue >= 6 && minValue < 8) return 6;
			else if (minValue >= 8 && minValue < 10) return 8;
			else if (minValue >= 10) return 10;
			else return 6;
		},
		countVias(minValue) {
			if(minValue === 0) return 0.3;
			else if (minValue < 0.15) return 0.15;
			else if (minValue >= 0.15 && minValue < 0.2) return 0.15;
			else if (minValue >= 0.2 && minValue < 0.25) return 0.2;
			else if (minValue >= 0.25 && minValue < 0.3) return 0.25;
			else if (minValue >= 0.3) return 0.3;
			else return 0.3;
		}
	}
}
</script>

<style lang="scss">
.quote-fileup_clear {
	cursor: pointer;
	float: right;
	height: 20px;
	line-height: 20px;
	&:hover{
		color:#c00;
	}
}
.quote-fileparse {
padding: 0px 20px 20px;
margin: 20px 0 10px;
border: 0.5px dashed #707070; }

.quote-loadfile-progress {
width: 450px;
height: 6px;
background-color: #e8e8e8;
border-radius: 6px;
overflow: hidden; }
.quote-loadfile-progress-step {
height: 6px;
border-radius: 6px;
background: #059a58;}

.quote-loadfile-file {
color: #666;
position: relative; }
.quote-loadfile-file .lt {
padding-right: 16px; }
.quote-loadfile-file .reupfile {
position: absolute;
top: 0;
width: 100%;
left: 0;
bottom: 0; }
.quote-loadfile-file .reupfile .webuploader-pick {
background: none; }

.quote-loadfile-above {
padding: 12px 20px 12px;
position: relative; }
.quote-loadfile-above::after {
content: "";
position: absolute;
left: 0;
top: 50%;
width: 4px;
height: 4px;
background-color: #666;
border-radius: 50%;
margin-top: -2px; }

.quote-loadfile-arg {
text-align: center;
padding: 10px 0 20px; }
.quote-loadfile-arg li {
padding: 6px 0; }

.quote-loadfile-tips {
background-color: #fff7eb;
padding: 10px 20px 15px 10px; }
.quote-loadfile-tips i {
float: left;
width: 14px;
height: 14px;
line-height: 14px;
text-align: center;
color: #fff;
font-size: 13px;
border-radius: 50%;
background-color: #faad14;
margin: 3px  15px 0 0; }
.quote-loadfile-tips p {
overflow: hidden;
font-size: 13px;
line-height: 1.5; }

.quote-loadfile-imgs {
padding: 0px 0 10px;
text-align: justify;
text-justify: distribute;
font-size: 0; }
.quote-loadfile-imgs .img {
border: 1px solid #e5e5e5;
padding: 15px; }
.quote-loadfile-imgs p {
height: 34px;
line-height: 34px; }

.quote-loadfile-btn {
text-align: right; }
.quote-loadfile-btn .lbtn {
width: 180px; }

.pcb-upgerber-file-box {
	.not-upload-box {
		width: 740px;
		background: #f8f8f8;
		padding: 18px 0;
		text-align: center;
		
	}
	.gerber-viewer-btn {
		cursor: pointer;
		display: inline-block;
		width: 273px;
		height: 38px;
		line-height: 38px;
		background:  #fff5f5;
		color: #CC0000;
		border: 1px solid #CC0000;
		text-align: center;
		border-radius: 2px;
		position: relative;
		z-index: 9;
		&:hover {
			background:  #CC0000;
			color: #fff;
			.quote-help {
				border-color: #fff;
				color: #fff;
			}
		}
	}
	.disabled-gerber-viewer {
		background: #ccc;
		border-color: #ccc;
		color:#fff;
		&:hover {
			color:#fff;
			background-color: #ccc;
			cursor: no-drop;
		}
	}
	.quote-help {
		//color: #fff;
		//border-color: #fff;
		margin-left: 8px;
	}
	.file-type-tip {
		color: #7B7B7B;
	}
	.quote-loadfile {
		width: 500px;
		margin: 0 auto;
	}
	.inconsistency-tip {
		color: #c7a572;
	}
}

.resolve-img{
	display: flex;
	justify-content: center;

	div {
		width: 380px;
		height: 200px;
		border: 1px solid #e5e5e5;
		padding: 15px;
		box-sizing: border-box;
		overflow: hidden;
	}

	div + div {
		margin-left: 30px;
	}

	img{
		width: 100%;
		height: 100%;
		object-fit:  contain;
	}
}

.analyzing-box-quote{
	width: 100%;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	background: #fff9f9;
	// padding: 40px 0 20px;
}

.analyzing-bg{
	background: #fff9f9 !important;
}

.flex-center{
	display: flex;
	justify-content: center;
	align-items: center;
}
.btn-border-close{
  width: 16px;
  height: 16px;
  cursor: pointer;
  color: #999;
  svg {
    width: 16px;
    height: 16px;
  }
  .icon-close{
    fill: #999;
  }

  &:hover{
    .icon-close {
      fill: #C00;
    }
  }
}
</style>
